export const NFL_TEAMS = {
  // AFC East
  BUF: { 
    name: 'Buffalo Bills', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/buf.png', 
    division: 'AFC East', 
    conference: 'AFC',
    espnId: 'buf'
  },
  MIA: { 
    name: 'Miami Dolphins', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/mia.png', 
    division: 'AFC East', 
    conference: 'AFC',
    espnId: 'mia'
  },
  NE: { 
    name: 'New England Patriots', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ne.png', 
    division: 'AFC East', 
    conference: 'AFC',
    espnId: 'ne'
  },
  NYJ: { 
    name: 'New York Jets', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/nyj.png', 
    division: 'AFC East', 
    conference: 'AFC',
    espnId: 'nyj'
  },
  
  // AFC North
  BAL: { 
    name: 'Baltimore Ravens', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/bal.png', 
    division: 'AFC North', 
    conference: 'AFC',
    espnId: 'bal'
  },
  CIN: { 
    name: 'Cincinnati Bengals', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/cin.png', 
    division: 'AFC North', 
    conference: 'AFC',
    espnId: 'cin'
  },
  CLE: { 
    name: 'Cleveland Browns', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/cle.png', 
    division: 'AFC North', 
    conference: 'AFC',
    espnId: 'cle'
  },
  PIT: { 
    name: 'Pittsburgh Steelers', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/pit.png', 
    division: 'AFC North', 
    conference: 'AFC',
    espnId: 'pit'
  },
  
  // AFC South
  HOU: { 
    name: 'Houston Texans', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/hou.png', 
    division: 'AFC South', 
    conference: 'AFC',
    espnId: 'hou'
  },
  IND: { 
    name: 'Indianapolis Colts', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ind.png', 
    division: 'AFC South', 
    conference: 'AFC',
    espnId: 'ind'
  },
  JAX: { 
    name: 'Jacksonville Jaguars', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/jax.png', 
    division: 'AFC South', 
    conference: 'AFC',
    espnId: 'jax'
  },
  TEN: { 
    name: 'Tennessee Titans', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ten.png', 
    division: 'AFC South', 
    conference: 'AFC',
    espnId: 'ten'
  },
  
  // AFC West
  DEN: { 
    name: 'Denver Broncos', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/den.png', 
    division: 'AFC West', 
    conference: 'AFC',
    espnId: 'den'
  },
  KC: { 
    name: 'Kansas City Chiefs', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/kc.png', 
    division: 'AFC West', 
    conference: 'AFC',
    espnId: 'kc'
  },
  LV: { 
    name: 'Las Vegas Raiders', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/lv.png', 
    division: 'AFC West', 
    conference: 'AFC',
    espnId: 'lv'
  },
  LAC: { 
    name: 'Los Angeles Chargers', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/lac.png', 
    division: 'AFC West', 
    conference: 'AFC',
    espnId: 'lac'
  },
  
  // NFC East
  DAL: { 
    name: 'Dallas Cowboys', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/dal.png', 
    division: 'NFC East', 
    conference: 'NFC',
    espnId: 'dal'
  },
  NYG: { 
    name: 'New York Giants', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png', 
    division: 'NFC East', 
    conference: 'NFC',
    espnId: 'nyg'
  },
  PHI: { 
    name: 'Philadelphia Eagles', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/phi.png', 
    division: 'NFC East', 
    conference: 'NFC',
    espnId: 'phi'
  },
  WAS: { 
    name: 'Washington Commanders', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/wsh.png', 
    division: 'NFC East', 
    conference: 'NFC',
    espnId: 'wsh'
  },
  
  // NFC North
  CHI: { 
    name: 'Chicago Bears', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/chi.png', 
    division: 'NFC North', 
    conference: 'NFC',
    espnId: 'chi'
  },
  DET: { 
    name: 'Detroit Lions', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/det.png', 
    division: 'NFC North', 
    conference: 'NFC',
    espnId: 'det'
  },
  GB: { 
    name: 'Green Bay Packers', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/gb.png', 
    division: 'NFC North', 
    conference: 'NFC',
    espnId: 'gb'
  },
  MIN: { 
    name: 'Minnesota Vikings', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/min.png', 
    division: 'NFC North', 
    conference: 'NFC',
    espnId: 'min'
  },
  
  // NFC South
  ATL: { 
    name: 'Atlanta Falcons', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png', 
    division: 'NFC South', 
    conference: 'NFC',
    espnId: 'atl'
  },
  CAR: { 
    name: 'Carolina Panthers', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/car.png', 
    division: 'NFC South', 
    conference: 'NFC',
    espnId: 'car'
  },
  NO: { 
    name: 'New Orleans Saints', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/no.png', 
    division: 'NFC South', 
    conference: 'NFC',
    espnId: 'no'
  },
  TB: { 
    name: 'Tampa Bay Buccaneers', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/tb.png', 
    division: 'NFC South', 
    conference: 'NFC',
    espnId: 'tb'
  },
  
  // NFC West
  ARI: { 
    name: 'Arizona Cardinals', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ari.png', 
    division: 'NFC West', 
    conference: 'NFC',
    espnId: 'ari'
  },
  LAR: { 
    name: 'Los Angeles Rams', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/lar.png', 
    division: 'NFC West', 
    conference: 'NFC',
    espnId: 'lar'
  },
  SF: { 
    name: 'San Francisco 49ers', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/sf.png', 
    division: 'NFC West', 
    conference: 'NFC',
    espnId: 'sf'
  },
  SEA: { 
    name: 'Seattle Seahawks', 
    logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/sea.png', 
    division: 'NFC West', 
    conference: 'NFC',
    espnId: 'sea'
  }
};

export const DIVISIONS = {
  'AFC East': ['BUF', 'MIA', 'NE', 'NYJ'],
  'AFC North': ['BAL', 'CIN', 'CLE', 'PIT'],
  'AFC South': ['HOU', 'IND', 'JAX', 'TEN'],
  'AFC West': ['DEN', 'KC', 'LV', 'LAC'],
  'NFC East': ['DAL', 'NYG', 'PHI', 'WAS'],
  'NFC North': ['CHI', 'DET', 'GB', 'MIN'],
  'NFC South': ['ATL', 'CAR', 'NO', 'TB'],
  'NFC West': ['ARI', 'LAR', 'SF', 'SEA']
};

export const getTeamsByConference = (conference) => {
  return Object.entries(NFL_TEAMS)
    .filter(([_, team]) => team.conference === conference)
    .map(([abbr, _]) => abbr);
};